import { Textarea, TextareaProps } from '@masterplandev/ui'

import useTranslation from '@/core/hooks/useTranslation'

export function PollTextarea(props: TextareaProps) {
  const { translate } = useTranslation('poll-controls')

  return (
    <Textarea
      rows={5}
      placeholder={translate('textarea.placeholder')}
      {...props}
    />
  )
}
